import { useModalStore, type IUseModalProps } from "@store/modal/modal";

export const useModal = (props: IUseModalProps) => {
  const { getState, close, remove } = useModalStore();
  const state = getState(props.id);

  if (!state) throw new Error(`Modal ${props.id} does not exist!`);

  return {
    ...props,
    state,
    close: () => close(props.id),
    remove: () => remove(props.id),
  };
};
